import { apiClient } from "../apiClient";
import {
  BACKEND_ENDPOINTS,
  LEGAL_CHAT_ENDPOINTS,
} from "../apiEndpoints";

const reWriteBaseUrl = process.env.REACT_APP_REPHRASE_TEXT_BASE_URL;

const CHAT_MODE_ENDPOINT_MAP = {
  balanced: LEGAL_CHAT_ENDPOINTS.HYBRID_CHAT,
  precise: LEGAL_CHAT_ENDPOINTS.STATUTE_CHAT,
  "case law": LEGAL_CHAT_ENDPOINTS.CASE_CHAT,
};

const CHAT_MODE_TYPE_MAP = {
  balanced: "hybrid",
  precise: "statute",
  "case law": "case",
};

export const sendChatMessageApi = async (userId, chatId, query, mode) => {
  const endpoint = CHAT_MODE_ENDPOINT_MAP[mode] || LEGAL_CHAT_ENDPOINTS.HYBRID_CHAT;
  const response = await apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${endpoint}`, {
    user_id: userId,
    chat_id: chatId,
    temperature: "precise",
    answer_length: "high",
    query,
  });
  return response.data;
};

export const sendStreamingChatMessageApi = async (conversationHistory, signal) => {
  const url = `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${LEGAL_CHAT_ENDPOINTS.STREAMING_CHAT}?stream=true&text_only=false`;
  return apiClient.stream(url, { conversation_history: conversationHistory }, signal);
};

export const createChatSessionApi = async (userId, chatId, mode, query, title) => {
  const type = CHAT_MODE_TYPE_MAP[mode] || "hybrid";
  const response = await apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${LEGAL_CHAT_ENDPOINTS.CREATE_CHAT_SESSION}`, {
    user_id: userId,
    chat_id: chatId,
    query: title,
    type,
    temperature: "precise",
    answer_length: "high",
  });
  return response.data;
};

export const saveChatHistoryApi = async (userId, chatId, messages) => {
  const response = await apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${LEGAL_CHAT_ENDPOINTS.SAVE_CHAT_HISTORY}`, {
    user_id: userId,
    chat_id: chatId,
    messages,
  });
  return response.data;
};

export const removeBookmarkedCaseApi = async (userId, groupId, caseId) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.DELETE_CASE_OR_STATUTE_FROM_GROUP}`,
    { userId, groupId, caseId },
  );
  return response;
};

export const removeBookmarkedStatuteApi = async (userId, groupId, statuteId) => {
  const response = await apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.DELETE_CASE_OR_STATUTE_FROM_GROUP}`,
    { userId, groupId, statuteId },
  );
  return response;
};

export const rephraseQueryApi = async (query) => {
  const response = await apiClient.post(reWriteBaseUrl, { query });
  return response.data;
};

export const baseChatApi = async (query, context) => {
  const response = await apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${LEGAL_CHAT_ENDPOINTS.BASE_CHAT}`, {
    temperature: "precise",
    answer_length: "high",
    query,
    context,
  });
  return response.data;
};
